<template>
  <v-row no-gutters class="fill-height">
    <v-col cols="12" class="fill-height">
      <v-row no-gutters class="pt-5 px-3" align="center" style="height: 48px !important">
        <v-col cols="auto" class="text-body-2 font-weight-bold primary-color"> {{ offersCountText }} </v-col>
        <v-spacer />
        <v-col cols="auto">
          <base-button text="buttons.clearFilters" text-icon="mdi-cancel" small @click="clearFilter" />
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-3 px-3 d-flex justify-space-between" align="center" style="height: 42px !important">
        <v-col v-for="(chip, idx) of filterChips" :cols="chip.cols" :key="idx">
          <data-input v-model="filterPayload[chip.name]" v-bind="chip.input" />
        </v-col>
        <v-col cols="auto" class="text-center">
          <v-badge overlap :content="filterPayloadLength" :value="filterPayloadLength || false" color="error">
            <base-button
              text-icon="mdi-tune"
              color="third"
              small
              height="30"
              width="36"
              class="mobile-filter-button"
              @click="isFilterVisible = true"
            />
          </v-badge>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-2" style="height: calc(100% - 90px) !important; overflow-y: auto">
        <v-col cols="12" class="fill-height">
          <v-virtual-scroll :items="currentOffers" item-height="92px" class="fill-height">
            <template #default="{ item: feature }">
              <v-row no-gutters class="mobile-list-offer">
                <v-col cols="4" style="height: 92px !important">
                  <v-row no-gutters class="fill-height" align="center" justify="center">
                    <v-col
                      cols="auto"
                      v-if="feature.properties[layers[feature.layerId].imageAttribute]"
                      style="max-height: 92px"
                    >
                      <img
                        :src="`${apiUrl}${feature.properties[layers[feature.layerId].imageAttribute]}`"
                        style="max-width: 100%; max-height: 92px"
                        loading="lazy"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8" class="text-body-2">
                  <v-row no-gutters class="colsAsRows pa-2">
                    <v-col
                      cols="auto"
                      class="font-weight-medium"
                      style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
                      @click.stop="$router.push({ name: 'offer', params: { lid: feature.layerId, fid: feature.id } })"
                    >
                      {{ feature.properties[offersAttributesNames.name] }}
                    </v-col>
                    <v-col cols="auto" class="font-weight-medium font-size-10" style="color: rgba(0, 0, 0, 0.6)">
                      {{
                        `${feature.properties[offersAttributesNames.commune]}, ${
                          feature.properties[offersAttributesNames.district]
                        }, ${feature.properties[offersAttributesNames.voivodeship]}`
                      }}
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                      <v-row no-gutters>
                        <v-col cols="auto" class="font-size-10" style="color: rgba(0, 0, 0, 0.37)">
                          {{ layers[feature.layerId].name }}
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto">
                          <v-chip
                            label
                            color="secondary"
                            text-color="white"
                            class="px-2 font-size-10 x-small"
                            style="height: 22px"
                          >
                            {{ `${feature.properties[offersAttributesNames.area]} ${areaAttributeUnit}` }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </v-virtual-scroll>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { get, sync } from 'vuex-pathify';

import BaseButton from '@/components/shared/buttons/BaseButton';
import DataInput from '@/components/shared/inputs/DataInput';

export default {
  name: 'TheMobileList',
  components: { BaseButton, DataInput },
  computed: {
    isFilterVisible: sync('tools/isFilterVisible'),
    filterPayload: sync('map/filterPayload'),
    filterPayloadLength() {
      return (
        Object.values(this.filterPayload)?.filter(v => (!!v || v === 0 || v === false) && v?.length !== 0).length || 0
      );
    },
    lngOffers: get('featuresData/lngOffers'),
    locationItems: get('featuresData/locationItems'),
    currentOffers: get('featuresData/currentOffers'),
    settingsValues: get('admin/settings'),
    currentLng() {
      return this.$i18n.locale;
    },
    currentLngAllOffers() {
      return this.lngOffers[this.currentLng]?.features || [];
    },
    offersCountText() {
      return `${this.$i18n.t('default.offers')}: ${this.currentOffers.length}/${this.currentLngAllOffers?.length}`;
    },
    filterChips() {
      return [
        {
          name: 'category',
          input: {
            dataType: { name: 'selectchip' },
            items: this.offersLayersIdsList,
            label: this.$i18n.t('dialog.search.category'),
          },
          cols: 3,
        },
        {
          name: 'voivodeship',
          input: {
            dataType: { name: 'selectchip' },
            items: this.locationItems.voivodeships,
            label: this.$i18n.t('dialog.search.voivodeship'),
          },
          cols: 4,
        },
        {
          name: 'district',
          input: {
            dataType: { name: 'selectchip' },
            items: this.locationItems.districts,
            label: this.$i18n.t('dialog.search.district'),
          },
          cols: 3,
        },
      ];
    },

    layers: get('featuresData/layers'),
    dataSources: get('featuresData/dataSources'),
    offersDataSource() {
      return this.dataSources[this.settingsValues['OFFERT_SETTING']?.value?.datasource];
    },
    areaAttributeUnit() {
      return (
        this.offersDataSource.attributes.find(attribute => attribute.name === this.offersAttributesNames.area)
          ?.measurement_unit?.symbol || ''
      );
    },
    offersAttributesNames() {
      const { value: offersSettingValue } = this.settingsValues['OFFERT_SETTING'];
      const { value: filterSettingValue } = this.settingsValues['FILTER_SETTING'];
      return {
        name: offersSettingValue.name_attribute,
        voivodeship: filterSettingValue?.attributes.voivodeship_attribute,
        district: filterSettingValue?.attributes.district_attribute,
        commune: filterSettingValue?.attributes.commune_attribute,
        area: offersSettingValue.area_attribute,
      };
    },
    offersLayersIds() {
      return this.$_config.languages.reduce((total, lng) => {
        total[lng] = ['brownfields', 'greenfields', 'invested'].reduce((tot, cur) => {
          tot[cur] = this.settingsValues[`${cur.toLocaleUpperCase()}_LAYERS_SETTING`]?.value?.layers?.[lng];
          return tot;
        }, {});
        return total;
      }, {});
    },
    offersLayersIdsList() {
      return Object.values(this.offersLayersIds[this.currentLng])
        .filter(layerId => !!layerId)
        .map(layerId => {
          return { text: this.layers[layerId]?.name, value: layerId };
        });
    },
  },
  data: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
  }),
  methods: {
    clearFilter() {
      this.filterPayload = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.colsAsRows {
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow-y: hidden;
}
.mobile-list-offer {
  @include border(bottom, 1px, rgba(0, 0, 0, 0.12));
}
.mobile-filter-button {
  min-width: unset !important;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>
